<script>
import getContext from '@/utilities/get-context';
import Sidebar from './sidebar/index';

export default {
  functional: true,
  render(h, ctx) {
    const firstName = getContext().__MA__.user.first_name || '';
    const subTitle = getContext().__MA__.account_subtitle || '';
    return (
      <div>
        <div class="bg-primary-purple pb-20 lg:pb-32">
          <div class="mx-auto px-5 lg:px-12 xl:px-20 3xl:max-w-[1720px] 3xl:px-0">
            <div class="py-10 lg:py-20">
              <h1 class="text-3xl lg:text-4xl font-bold text-white">
                Welcome back{firstName ? ` ${firstName}` : ''},
              </h1>
              {h('p', { class: 'mt-1 text-b85', domProps: { innerHTML: subTitle } })}
            </div>
            <div class="flex flex-wrap lg:flex-nowrap">
              <div class="left mb-8 lg:mb-0">
                <Sidebar />
              </div>
              <div class="lg:pl-10 right">
                {typeof ctx.scopedSlots.default === 'function' ? ctx.scopedSlots.default() : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
};
</script>

<style scoped>
.container {
  max-width: 1450px;
}
.left,
.right {
  @apply w-full;
}
@screen lg {
  .bg {
    background-size: 100% 200px;
  }
  .left {
    width: 330px;
  }
  .right {
    width: calc(100% - 330px);
  }
}
@screen 3xl {
  .\33xl\:max-w-\[1720px\] {
    max-width: 1720px;
  }
}
</style>
